export default {
  site: {
    name: "媚肉之香",
    slogan: "探索香与肌肤之间最深层的共鸣",
    description: "融合东方香氛美学与肌肤养护精髓，唤醒内在魅力与自信",
  },
  nav: {
    home: "首页",
    fragrance: "香氛系列",
    skincare: "肌肤养护",
    articles: "香氛文章",
    about: "关于我们",
  },
  footer: {
    copyright: "版权所有",
    privacy: "隐私政策",
    terms: "服务条款",
    cookies: "Cookie 设置",
  },
};